<template>
  <v-card
    elevation="2"
    :class="className"
    flat
    @click="handleClick"
  >
    <table class="pt-2 pb-2 pl-2 pr-2 mb-2">
      <tr class="course-tr">
        <td class="mr-5 nowarp">
          Center:
        </td>
        <td class="course-content">
          {{ orderData.center.code }}
        </td>
      </tr>
      <tr class="course-tr">
        <td class="mr-5 nowarp">
          Course Name:
        </td>
        <td class="course-content">
          {{ orderData.course.courseName }}
        </td>
      </tr>
      <tr class="course-tr">
        <td class="mr-5 nowarp">
          Course Code:
        </td>
        <td class="course-content">
          {{ orderData.course.courseCode }}
        </td>
      </tr>
      <tr class="course-tr">
        <td class="mr-5 nowarp">
          Duration:
        </td>
        <td class="course-content">
          {{ orderData.course.duration }}
        </td>
      </tr>
    </table>
  </v-card>
</template>
<script setup>
import { ref, toRefs, watch } from 'vue'
import order from '@/store/modules/order'

const defaultClassName = 'item-card ml-2 mr-2 booking-transfer-item'
const selectedClassName = `${defaultClassName} selected-item`

const props = defineProps({
  orderData: {
    type: Object,
    default() {
      return {
        center: {
          code: 'TW',
        },
        course: {
          courseName: 'EM',
          courseCode: 'C001',
          duration: 60,
        },
        selected: false,
      }
    },
  },
  selected: {
    type: Boolean,
    default: false,
  },
})
const { orderData, selected } = toRefs(props)
const className = ref(defaultClassName)
watch(selected, val => {
  if (val) {
    className.value = selectedClassName
  } else {
    className.value = defaultClassName
  }
})

const emit = defineEmits(['click', 'remove'])

const selectedOrder = ref({})

function handleClick(e) {
  console.log('orderItem clicked', orderData.value)
  if (selectedOrder.value && selectedOrder.value.id === orderData.value.id) {
    selectedOrder.value = null

    // className.value = defaultClassName
    emit('remove')
  } else {
    selectedOrder.value = orderData.value

    // className.value = selectedClassName
    emit('click', orderData.value)
  }
}
</script>
<style scoped>
.item-card{
  display: inline-block !important;
  white-space: nowrap;
  cursor: pointer;
}

.booking-transfer-item{
  max-width: 300px;
}
.nowarp{
  white-space: nowrap;
}
.course-content{
  padding-left: 5px;
  /* float: right; */
}
.selected-item{
  border-width: 2px;
  border-radius: 5px;
  border-style: solid;
  border-color: #566369;
}
</style>
